import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { deactiveSubOccupation } from "../../actions/shg";

const DeactiveSubOccupation = ({
  auth: { isAuthenticated, user, users },
  allSubOccupation,
  deactiveSubOccupation,
  onDeactiveModalChange,
}) => {
  const [formData, setFormData] = useState({
    subOccupationDeactiveReason: "",
    isSubmitted: false,
  });

  const { subOccupationDeactiveReason } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: allSubOccupation ? allSubOccupation._id : "",
      subOccupationStatus: "Deactive",
      subOccupationDeactiveReason: subOccupationDeactiveReason,
      subOccupationDeactiveById: user && user._id,
      subOccupationDeactiveByName: user && user.userName,
      subOcccupationDeactiveDateTime: new Date().toLocaleString("en-GB"),
    };
    deactiveSubOccupation(finalData);
    onDeactiveModalChange(true);
  };

  return !isAuthenticated || !user || !users ? (
    <Fragment></Fragment>
  ) : (
    <Fragment>
      <div className="col-lg-12 col-md-9 col-sm-9 col-12 ">
        <form className="row" onSubmit={(e) => onSubmit(e)}>
          <div className="row col-lg-12 col-md-9 col-sm-9 col-12 ">
            <div className="col-lg-12 col-md-4 col-sm-4 col-12">
              <label>Reason For Deactivation* :</label>
            </div>
            <div className="col-lg-12  col-md-4 col-sm-4 col-12">
              <textarea
                name="subOccupationDeactiveReason"
                id="subOccupationDeactiveReason"
                className="textarea form-control"
                rows="3"
                placeholder="Deactive Reason"
                onChange={(e) => onInputChange(e)}
                style={{ width: "100%" }}
                required
              ></textarea>
            </div>
            <div className="col-lg-12 col-md-4 col-sm-4 col-12 py-2">
              <label>Are You Sure You Want to Deactivate ??</label>
            </div>
            <div
              className="col-lg-12 col-md-9 col-sm-9 col-12 Savebutton"
              size="lg"
            >
              <input
                type="submit"
                name="Save"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

DeactiveSubOccupation.propTypes = {
  auth: PropTypes.object.isRequired,
  deactiveSubOccupation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { deactiveSubOccupation })(
  DeactiveSubOccupation
);
